import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import AppController from "../../controller/appController";
// import schoolData from "./greatSchoolsData.json";

function GreatSchoolsPage(props) {
  const [state, setState] = useState({
    allScools: [],
    greatSchools: [],
    privateScools: [],
    publicScools: [],
    charterScools: [],
  });
  useEffect(() => {
    if (props.community != undefined) {
      getSchoolData(props.community);
    }
  }, [props.community]);

  const updateState = (updateObj) => {
    setState((prevObj) => ({ ...prevObj, ...updateObj }));
  };
  const getSchoolData = async (communityData) => {
    try {
      const greatSchools = await AppController.greatSchools2(communityData);

      // let TotalData = schoolData;
      if (!greatSchools || !Array.isArray(greatSchools.schools)) {
        console.log("No valid 'schools' data found in greatSchools response");
        updateState({
          allScools: [],
          greatSchools: {},
          privateScools: [],
          publicScools: [],
          charterScools: [],
        });
        return;
      }
      const privateScools = _.filter(greatSchools.schools, function (o) {
        o.schoolSummary = o["school-summary"];
        o.overviewUrl = o["overview-url"];
        return o.type == "private";
      });
      const publicScools = _.filter(greatSchools.schools, function (o) {
        o.schoolSummary = o["school-summary"];
        o.overviewUrl = o["overview-url"];
        return o.type == "public";
      });
      const charterScools = _.filter(greatSchools.schools, function (o) {
        o.schoolSummary = o["school-summary"];
        o.overviewUrl = o["overview-url"];
        return o.type == "charter";
      });
      updateState({
        allScools: publicScools,
        greatSchools: greatSchools,
        privateScools: privateScools,
        publicScools: publicScools,
        charterScools: charterScools,
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  const handleClick = async (type) => {
    $(".nav-item").removeClass("active");
    $("#" + type).addClass("active");
    var data = [];
    if (type == "private") {
      data = state.privateScools;
    } else if (type == "public") {
      data = state.publicScools;
    } else if (type == "charter") {
      data = state.charterScools;
    }
    await updateState({
      allScools: data,
    });
  };

  return (
    <div>
      <h3>Schools</h3>
      <div className="SAweb_neighbourhood schTabs">
        <ul className="nav nav-tabs p-0">
          <li
            className="nav-item active"
            id="public"
            onClick={() => handleClick("public")}
          >
            <button
              className="nav-link "
              id="public2"
              type="button"
              aria-selected="true"
            >
              Public
            </button>
          </li>
          <li
            className="nav-item"
            id="private"
            onClick={() => handleClick("private")}
          >
            <button
              className="nav-link "
              id="private2"
              type="button"
              aria-selected="true"
            >
              Private
            </button>
          </li>
          <li
            className="nav-item"
            id="charter"
            onClick={() => handleClick("charter")}
          >
            <button
              className="nav-link "
              id="charter2"
              type="button"
              aria-selected="true"
            >
              Charter
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button className="nav-link splbtn">
              Data provided by{" "}
              <a target={"_blank"} href="https://www.greatschools.org/">
                {" "}
                GreatSchools{" "}
              </a>{" "}
            </button>
          </li>
        </ul>
        <div className="tab-content myTabContentVIew SAweb_schools">
          <div
            className="tab-pane fade in active"
            id="public"
            role="tabpanel"
            aria-labelledby="public-tab"
          >
            <section className=" bg-white">
              {state.allScools.length > 0 ? (
                <div className="owl-slider pb-5 SAweb_sliderBottomArrows billingSlider">
                  <div id="carouselSchool">
                    <OwlCarousel
                      className="owl-theme owl-carousel"
                      {...{
                        loop: false,
                        margin: 10,
                        nav: true,
                        dots: false,
                        items: 1,
                        navContainerClass: "owl-buttons",
                        navText: [
                          "<i class='glyphicon glyphicon-menu-left'></i>",
                          "<i class='glyphicon glyphicon-menu-right'></i>",
                        ],
                        responsive: {
                          600: { items: 1, loop: false },
                          767: { items: 2, loop: false },
                          992: { items: 2, loop: false },
                          1199: { items: 3, loop: false },
                        },
                      }}
                    >
                      {state.allScools.map((row, index) => {
                        return (
                          <div className="item" key={index}>
                            <div className="caption">
                              <p>
                                <a target="_blank" href={row.overviewUrl}>
                                  {row.name}
                                </a>
                              </p>
                              <p className="data">
                                {" "}
                                <span>
                                  {row.schoolSummary.substring(0, 213)}
                                  {row.schoolSummary.length > 216 ? "... " : ""}
                                  {row.schoolSummary.length > 216 ? (
                                    <a target="_blank" href={row.overviewUrl}>
                                      more
                                    </a>
                                  ) : (
                                    ""
                                  )}
                                </span>{" "}
                              </p>
                              <ul>
                                {row.rating != null ? (
                                  <li>
                                    {" "}
                                    <i className="bi bi-star-fill"> </i>{" "}
                                    {row.rating}/10{" "}
                                  </li>
                                ) : (
                                  <li></li>
                                )}
                                <li>
                                  {" "}
                                  <i className="bi bi-telephone"> </i>{" "}
                                  {row.phone}
                                </li>
                              </ul>
                            </div>
                          </div>
                        );
                      })}
                    </OwlCarousel>
                  </div>
                </div>
              ) : (
                <div className="no_data_found">No Data Found!</div>
              )}
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GreatSchoolsPage;
